<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Steps
import Umsaekjandi from '../../Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'
import Step6 from './Step6.vue'
import Step7 from './Step7.vue'
import Step8 from './Step8.vue'
import Step9 from './Step9.vue'
import Step10 from './Step10.vue'
import Step11 from './Step11.vue'
import Step12 from './Step12.vue'
import Step13 from './Step13.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

defineProps<{
  disable?: boolean
}>()

const expanded = ref([0])

defineExpose({
  validate() {
    return true
  }
})

// steps for summary (exclude begin + this one)
const summarySteps = [
  { comp: Umsaekjandi, titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2, titleKey: 'umsokn_bankareikningur_header1' },
  { comp: Step3, titleKey: 'ororku_umsokn_step3_header_1' },
  { comp: Step4, titleKey: 'ororku_umsokn_step4_header' },
  { comp: Step5, titleKey: 'ororku_umsokn_step4_header' },
  { comp: Step6, titleKey: 'ororku_umsokn_step5_header' },
  { comp: Step7, titleKey: 'ororku_umsokn_step6_header' },
  { comp: Step8, titleKey: 'ororku_umsokn_step7_header' },
  { comp: Step9, titleKey: 'ororku_umsokn_step8_header' },
  { comp: Step10, titleKey: 'ororku_umsokn_step9_header' },
  { comp: Step11, titleKey: 'ororku_umsokn_step10_header' },
  { comp: Step12, titleKey: 'ororku_umsokn_step11_header' },
  { comp: Step13, titleKey: 'ororku_umsokn_step12_header' }
]
</script>

<template>
  <div v-if="umsokn" class="col-sm-12">
    <v-col>
      <!-- Header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">{{ t('umsokn_samantekt_header') }}</h2>
        </v-col>
      </v-row>

      <!-- Summary panels -->
      <v-row>
        <v-col class="application__summary">
          <v-expansion-panels v-model="expanded" multiple>
            <v-expansion-panel
              v-for="(step, i) in summarySteps"
              :key="i"
            >
              <v-expansion-panel-title>
                {{ t(step.titleKey) }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <component :is="step.comp" :umsokn="umsokn" :disable="true" class="m-t-40" />
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Disclaimer -->
      <v-row>
        <v-col>
          <p class="forms__paragraph">
            {{ t('lifeyri_umsokn_step6_disclaimer_text') }}
          </p>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped>
.m-t-40 {
  margin-top: 40px;
}
</style>
